import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import {Headers, RequestOptions} from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { UtilsService } from '../../shared/utils-service';

@Component({
  selector: 'app-batch-upload-status',
  templateUrl: './batch-upload-status.component.html',
  styleUrls: ['./batch-upload-status.component.css']
})
export class BatchUploadStatusComponent implements OnInit {

  private batchDetails: any = {};
	private batchDetailsList: any[] = [];
	jsonRes: any = {};
	private loggedInUser: any = {};
	//private url: string = this.utils.url+"/ddmfBulkEnquiry/batchEnquirySearch";
	private url: string = this.utils.url+"/ddmfBulkEnquiry/batchEnquirySearch";
    
    constructor(private http: Http, private matSnackBar: MatSnackBar, private utils: UtilsService) {
  	this.searchBatchDetails();
  	this.loggedInUser = this.utils._checkSession({'page': 'mass-search-customers'});
   }
    
  ngOnInit() {
  }
  
  searchBatchDetails(){
  	//console.log(this.batchDetails);
  	let req = {
  		"userId" : this.loggedInUser.userId,
  		"batchId" : this.batchDetails.batchId,
  		"fileName" : this.batchDetails.fileName,
  		"status" : this.batchDetails.status,
  		"dateRangeFrom" : this.batchDetails.dateRangeFrom,
  		"dateRangeTo" : this.batchDetails.dateRangeTo
  	};
  	//console.log(req);
  	//this.batchUploadHistoryService.searchBatchDetails(req).subscribe(data => this.jsonRes = data);
  	
  	//console.log(JSON.stringify(req));
  	this.saerchBatchDetailsService(req).subscribe(data => this.jsonRes = data);
  	if(this.jsonRes.batchList!=null)
  	{
  		this.batchDetailsList = this.jsonRes.batchList;
  	}
  	//console.log(this.batchDetailsList);
  }
  
  saerchBatchDetailsService(req)
  {
  	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);

	//console.log(JSON.stringify(req));
	
	let res =  this.http.post(this.url, JSON.stringify(req), { headers: headers });
		if(res!=null){
		//console.log(res, 'if');
			res = res.map(res => res.json());
		} else {
		
		//console.log(res, 'else');
			
		}
		return res;
		
  }
}


// WEBPACK FOOTER //
// ./src/app/mass-search-customers/batch-upload-status/batch-upload-status.component.ts